"use client"
import { motion, AnimatePresence } from "framer-motion"
import { ChevronDown } from "lucide-react"

const OtherSourcesSection = ({ title, amount, isExpanded, onToggle, items, isMenu, onInputChange }) => {
  return (
    <div
      className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden mb-4"
      style={{ borderRadius: "10px" }}
    >
      <button onClick={onToggle} className="w-full px-4 py-3 flex items-center justify-between hover:bg-gray-50">
        <span className="font-medium text-gray-700">{title}</span>
        <div className="flex items-center gap-4">
          <span className="font-medium">₹ {amount}</span>
          <motion.div animate={{ rotate: isExpanded ? 180 : 0 }} transition={{ duration: 0.2 }}>
            {isMenu ? <ChevronDown className="w-5 h-5 text-gray-400" /> : <>&nbsp; &nbsp; &nbsp;</>}
          </motion.div>
        </div>
      </button>

      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            transition={{ duration: 0.2 }}
            className="overflow-hidden"
          >
            {isMenu && (
              <div className="py-3 bg-gray-50">
                {items.map((item, i) => (
                  <div key={item.id} className={`${i % 2 === 1 ? "bg-[#E5F6FE]" : ""}`}>
                    <div className="flex px-4 items-center gap-4">
                      <label className="text-sm text-gray-600 flex-1">{item.label}</label>
                      <div className="relative w-48 py-1">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">₹</span>
                        <input
                          type={item.type ? item.type : "text"}
                          className={`w-full pl-8 pr-3 py-2 text-right rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#00A3FF] focus:border-transparent ${item.isModal ? "cursor-pointer bg-gray-50" : ""}`}
                          value={item.value}
                          onChange={(e) => onInputChange(item.id, e.target.value, false, item.id)}
                          onClick={() => item.isModal && onInputChange(item.id, item.value, false, item.id)}
                          readOnly={item.isModal}
                          style={{ borderRadius: "10px" }}
                        />
                      </div>
                    </div>

                    {item.submenu && (
                      <>
                        {item.submenu.map((submenu, idx) => (
                          <div key={submenu.id} className="flex px-4 ml-5 items-center gap-4">
                            <label className="text-sm text-gray-600 flex-1">{submenu.label}</label>
                            {submenu.isNotField === true ? (
                              <div className="relative w-48 py-6"></div>
                            ) : (
                              <div className="relative w-48 py-1">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">₹</span>
                                <input
                                  type={item.type ? item.type : "text"}
                                  className={`w-full pl-8 pr-3 py-2 text-right rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#00A3FF] focus:border-transparent ${submenu.isModal ? "cursor-pointer bg-gray-50" : ""}`}
                                  value={submenu.value}
                                  onChange={(e) => onInputChange(item.id, e.target.value, true, submenu.id)}
                                  onClick={() =>
                                    submenu.isModal && onInputChange(item.id, submenu.value, true, submenu.id)
                                  }
                                  readOnly={submenu.isModal}
                                  style={{ borderRadius: "10px" }}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                ))}
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default OtherSourcesSection
